import { generatePath } from 'react-router-dom';
import { links } from '../../../constants/links';

const {
  rootWithCompany,
  houses,
  house: {
    pages: { flats, tenants, info, meters, personalAccounts },
  },
} = links;

const getLink = (params, housePage) => {
  const { companyId, pageId: houseId } = params;
  if (companyId && houseId) {
    return generatePath(
      `${rootWithCompany}/:companyId/${houses}/:houseId/:housePage`,
      {
        companyId,
        houseId,
        housePage,
      }
    );
  } else {
    return '';
  }
};

export const getMenu = (params) => [
  {
    key: flats,
    content: 'Помещения',
    link: getLink(params, flats),
  },
  {
    key: tenants,
    content: 'Жители дома',
    link: getLink(params, tenants),
  },
  {
    key: info,
    content: 'Информация',
    link: getLink(params, info),
  },
  {
    key: meters,
    content: 'ОДПУ',
    link: getLink(params, meters),
  },
  {
    key: personalAccounts,
    content: 'Лицевые счета',
    link: getLink(params, personalAccounts),
  },
];
